'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.default = createCreators;

var _fsaActionCreatorFactory = require('./fsaActionCreatorFactory');

var _fsaActionCreatorFactory2 = _interopRequireDefault(_fsaActionCreatorFactory);

var _apiActionCreatorFactory = require('./apiActionCreatorFactory');

var _apiActionCreatorFactory2 = _interopRequireDefault(_apiActionCreatorFactory);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getFactory(singleConfig) {
  return !singleConfig || !singleConfig.url ? _fsaActionCreatorFactory2.default : _apiActionCreatorFactory2.default;
}

var DEFAULT_CONFIG = {};
/*
  @param {Object} config - original config object provided to createActions
  @param {Object} actionTypes - action types object with keys being the original names and the value
  being the uppercased namespace + uppercased name.
*/

function createCreators(config, actionTypes) {
  return Object.keys(config).reduce(function (acc, creatorName) {
    var _extends2;

    var singleConfig = config[creatorName] || DEFAULT_CONFIG;
    var factory = getFactory(singleConfig);
    return _extends({}, acc, (_extends2 = {}, _extends2[creatorName] = factory(singleConfig, actionTypes[creatorName]), _extends2));
  }, {});
}